/* src/app/components/payroll/purchase-request/purchase-request-edit-history/purchase-request-edit-history.component.css */
.expand-row-icon-btn {
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
}
.table-header-main {
  font-weight: bold;
  font-size: 14px;
  color: black;
}
.edit-history-content {
  border: 1px solid #1c1b1b !important;
  margin: 16px 10px !important;
  border-radius: 4px !important;
}
.action-container {
  padding-left: 0px !important;
}
/*# sourceMappingURL=purchase-request-edit-history.component-HUC5RZG6.css.map */
